// extracted by mini-css-extract-plugin
export default {"DynamicIcon":"WidgetIcon_DynamicIcon__HfTk+"};